import styles from './NotFound.module.css';
import { LanguageContext } from '../../context/LanguageContext';

export default function NotFound() {
  return (
    <LanguageContext.Consumer>
      {({ data, language: ctxLang }) => {
        const t = (key) => data?.[key]?.[ctxLang];

        return (
          <div className={styles.root}>
            <div className={styles.imageWrapper}>
              <img src="/assets/notFound/vinni-not-found.png" alt="" width={400} height={400}/>
            </div>
            <p className={styles.subtitle}>{t('not_found_title')}</p>
            <p className={styles.description}>{t('not_found_description')}</p>
            <a href={'/'} className={styles.linkPlain}>
              <button className={styles.backButton}>
                {t('back_to_home')}
              </button>
            </a>
            <a href={'/products'} className={styles.browseLink}>
              {t('not_found_subtitle')}
            </a>
            <div className={styles.divider}>
              <div className={styles.dividerLine} />
              <div className={styles.dividerDot} />
              <div className={styles.dividerLine} />
            </div>
          </div>
        );
      }}
    </LanguageContext.Consumer>
  );
}